import React, { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import Currency from '@v2/shared/components/Currency';
import { useSite } from '@v2/shared/lib/site';

type Props = { value: number; className?: string; children?: ReactNode };

/**
 * A price, in the site's currency.
 *
 * The class list is merged rather than concatenated, so a caller's `className` replaces the
 * default it collides with instead of being appended to it. Concatenating left both colours
 * on the element and handed the choice to the cascade, which `text-slate-900` won: the
 * compiled sheet emits it after `text-primary-600` and after `text-red-600` alike, so every
 * colour a caller passed was accepted and then ignored.
 */
export default function Price({ value, className, children }: Props) {
  const site = useSite();

  return (
    <span className={twMerge('font-bold tracking-tighter text-slate-900', className)}>
      <Currency value={value} currencyCode={site.currency} />
      {children}
    </span>
  );
}
